'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaAmbulance = function FaAmbulance(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13 30.4q0-1.1-0.8-1.8t-1.8-0.8-1.8 0.8-0.8 1.8 0.8 1.8 1.8 0.8 1.8-0.8 0.8-1.8z m-7.8-10.4h7.8v-5.2h-3.2q-0.3 0-0.5 0.2l-3.9 3.9q-0.2 0.3-0.2 0.5v0.6z m26 10.4q0-1.1-0.8-1.8t-1.8-0.8-1.9 0.8-0.7 1.8 0.7 1.8 1.9 0.8 1.8-0.8 0.8-1.8z m2.6-13.6v-3.9q0-0.3-0.2-0.5t-0.5-0.2h-4.5v-4.5q0-0.3-0.2-0.5t-0.5-0.2h-3.9q-0.3 0-0.4 0.2t-0.2 0.5v4.5h-4.6q-0.3 0-0.4 0.2t-0.2 0.5v3.9q0 0.2 0.2 0.4t0.4 0.2h4.6v4.5q0 0.3 0.2 0.5t0.4 0.2h3.9q0.3 0 0.5-0.2t0.2-0.5v-4.5h4.5q0.3 0 0.5-0.2t0.2-0.4z m5.2-11.1v23.4q0 0.5-0.4 0.9t-0.9 0.4h-3.9q0 2.1-1.6 3.7t-3.6 1.5-3.7-1.5-1.5-3.7h-7.8q0 2.1-1.5 3.7t-3.7 1.5-3.7-1.5-1.5-3.7h-2.6q-0.5 0-0.9-0.4t-0.4-0.9 0.4-0.9 0.9-0.4v-8.4q0-0.6 0.3-1.2t0.6-1.1l4-4q0.4-0.4 1.1-0.6t1.1-0.3h3.3v-6.5q0-0.5 0.4-0.9t0.9-0.4h23.4q0.5 0 0.9 0.4t0.4 0.9z' })
        )
    );
};

exports.default = FaAmbulance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/ambulance.js
// module id = 68
// module chunks = 58411574672382 79611799117203 84521481881339